module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-125.422fee8a.svg";